import { render, staticRenderFns } from "./addCertification.vue?vue&type=template&id=3f2b318a&scoped=true"
import script from "./addCertification.vue?vue&type=script&lang=js"
export * from "./addCertification.vue?vue&type=script&lang=js"
import style0 from "./addCertification.vue?vue&type=style&index=0&id=3f2b318a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b318a",
  null
  
)

export default component.exports